// Gets the hex color value given a Palette color
import {Palette} from '../../models/palette';
import {paletteValues} from '../../models/palette-values';

export const getPaletteValue = (color: Palette) =>
	paletteValues.find(c => c.color === color)?.value;
